import NftMesg from './index';

export default { path: '/home/nft', component: NftMesg };
